import { Injectable } from '@angular/core';
import { HttpPromiseService } from './http-promise.service';
import { Device } from '@ionic-native/device/ngx';

@Injectable({
  providedIn: 'root'
})
export class DeviceChangeService {
  constructor(
    private httpPromiseService: HttpPromiseService,
    private device: Device
  ) {}

  async getDeviceUUID(): Promise<string> {
    if (this.device.uuid) {
      return this.device.uuid;
    } else {
      console.warn('Device UUID not available.');
      return 'unknown-uuid';
    }
  }

  async getDeviceInfoString(): Promise<string> {
    let deviceInfoString = 'Device information not available.';
    if (this.device.cordova) {
      try {
        const model = this.device.model || 'N/A';
        const platform = this.device.platform || 'N/A';
        const version = this.device.version || 'N/A';
        const manufacturer = this.device.manufacturer || 'N/A';
        const uuid = this.device.uuid || 'N/A';
        const isVirtual = this.device.isVirtual ? 'Yes' : 'No';

        deviceInfoString = `Model: ${model}, Platform: ${platform}, OS Version: ${version}, Manufacturer: ${manufacturer}, UUID: ${uuid}, Virtual: ${isVirtual}`;
      } catch (e) {
        console.error('Error accessing device properties:', e);
        deviceInfoString = 'Error retrieving some device details.';
      }
    }
    return deviceInfoString;
  }

  async requestDeviceChange(email: string): Promise<any> {
    const currentDeviceUUID = await this.getDeviceUUID();
    const deviceInfoString = await this.getDeviceInfoString();

    const payload = {
      email: email.toLowerCase(),
      newDeviceUUID: currentDeviceUUID,
      newDeviceInfo: deviceInfoString
    };

    return this.httpPromiseService.httpPostRequest('/api/device-change-requests', payload);
  }
}